import React from 'react';
import PropTypes from 'prop-types';
import { Search } from 'lucide-react';
import Select from 'react-select';
import NumericInput from 'react-numeric-input';
import styles from './ActionCenterHeader.module.css';

export const ActionCenterHeader = ({ 
  searchValue, 
  onSearchChange,
  timeValue = 12,
  onTimeChange,
  timeUnit = 'days',
  onUnitChange,
  actionPack,
  onActionPackChange
}) => {
  const actionPackOptions = [
    { value: 'all', label: 'Action Pack' },
    { value: 'sap', label: 'SAP' },
    { value: 'db', label: 'Database' },
    { value: 'infra', label: 'Infrastructure' }
  ];

  const timeUnitOptions = [
    { value: 'minutes', label: 'Minutes' },
    { value: 'hours', label: 'Hours' },
    { value: 'days', label: 'Days' },
    { value: 'weeks', label: 'Weeks' }
  ];

  return (
    <header className={styles.header}>
      <div className={styles.titleSection}>
        <h1 className={styles.title}>Action Center</h1>
      </div>
      <div class="header-buttons">
      <div className={styles.filtersSection}>
        {/* Search Input */}
        <div class="time-input-interval">
        <div className={styles.searchContainer}>
          <Search className={styles.searchIcon} />
          <input
            type="text"
            placeholder="Search Tickets"
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            className={styles.searchInput}
          />
        </div>
        </div>


        {/* Time Selector */}
          <div class="time-input-interval">
            <div className={styles.timeSelector}>
              <NumericInput
                min={1}
                value={timeValue}
                onChange={(value) => onTimeChange(value)}
                className={styles.numberInput}
                mobile
                strict
                size={4}
                style={{
                  input: {
                    backgroundColor: "#1f1f1f",
                    color: "#fff",
                    border: "1px solid #555",
                    borderRadius: "6px",
                    height: "36px",
                    width: "80px",
                  },
                  btn: {
                    background: "#434343ff",
                    color: "#ffffffff",
                    border: "none",
                  },
                }}
              />

              <Select
                value={timeUnitOptions.find((o) => o.value === timeUnit)}
                onChange={(option) => onUnitChange(option.value)}
                options={timeUnitOptions}
                className={styles.select}
                classNamePrefix="react-select"
                isSearchable={false}
                menuPlacement="auto"
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 6,
                  colors: {
                    ...theme.colors,
                    primary25: "#2a2a2a",
                    primary50: "#1f1f1f",
                    primary: "#232526",
                    neutral0: "#1f1f1f",
                    neutral20: "#555",
                    neutral80: "#fff",
                  },
                })}
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: "#1f1f1f",
                    borderColor: "#555",
                    minHeight: 36,
                    height: 36,
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: "#fff",
                  }),
                  menu: (base) => ({
                    ...base,
                    backgroundColor: "#1f1f1f",
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isSelected
                      ? "#f51032"
                      : state.isFocused
                      ? "#2a2a2a"
                      : "#1f1f1f",
                    color: "#fff",
                  }),
                }}
              />
            </div>
          </div>



        {/* Action Pack Dropdown */}
        <div class="action-dropdown">
        <div className={styles.filterContainer}>
          <Select
            value={actionPackOptions.find((o) => o.value === actionPack)}
            onChange={(option) => onActionPackChange(option.value)}
            options={actionPackOptions}
            className={styles.select}
            classNamePrefix="react-select"
            isSearchable={false}
            menuPlacement="auto"
            theme={(theme) => ({
              ...theme,
              borderRadius: 6,
              colors: {
                ...theme.colors,
                primary25: "#2a2a2a",
                primary50: "#1f1f1f",
                primary: "#232526",
                neutral0: "#1f1f1f",
                neutral20: "#555",
                neutral80: "#fff",
              },
            })}
            styles={{
              control: (base) => ({
                ...base,
                backgroundColor: "#1f1f1f",
                borderColor: "#555",
                minHeight: 36,
                height: 36,
              }),
              singleValue: (base) => ({
                ...base,
                color: "#fff",
              }),
              menu: (base) => ({
                ...base,
                backgroundColor: "#1f1f1f",
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected
                  ? "#f51032"
                  : state.isFocused
                  ? "#2a2a2a"
                  : "#1f1f1f",
                color: "#fff",
              }),
            }}
          />
        </div>
        </div>

      </div>
      </div>


    </header>
  );
};

ActionCenterHeader.propTypes = {
  searchValue: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  timeValue: PropTypes.number,
  onTimeChange: PropTypes.func.isRequired,
  timeUnit: PropTypes.string,
  onUnitChange: PropTypes.func.isRequired,
  actionPack: PropTypes.string.isRequired,
  onActionPackChange: PropTypes.func.isRequired
};